export const POP_PRODUCTION_REQUEST = 'POP_PRODUCTION_REQUEST';
export const POP_DESIGN_REQUEST = 'POP_DESIGN_REQUEST';
export const CARD_DESIGN_REQUEST = 'CARD_DESIGN_REQUEST';
export const PRODUCTION_REQUEST = 'PRODUCTION_REQUEST';
export const FINANCIAL_SERVICES_REQUEST = 'FINANCIAL_SERVICES_REQUEST';
export const BIF_PRODUCTION_REQUEST = 'BIF_PRODUCTION_REQUEST';
export const PRODUCTION_REQUEST_3RD_PARTY = 'PRODUCTION_REQUEST_3RD_PARTY';
export const DIGITAL_ASSETS_REQUEST = 'DIGITAL_ASSETS_REQUEST';
export const IH_PRODUCTION_REQUEST = 'IH_PRODUCTION_REQUEST';
export const IMAGE_REQUEST = 'IMAGE_REQUEST';

export const SUPPORTED_REQUEST_TYPES = [
  POP_PRODUCTION_REQUEST,
  POP_DESIGN_REQUEST,
  CARD_DESIGN_REQUEST,
  PRODUCTION_REQUEST,
  FINANCIAL_SERVICES_REQUEST,
  BIF_PRODUCTION_REQUEST,
  PRODUCTION_REQUEST_3RD_PARTY,
  IH_PRODUCTION_REQUEST,
  IMAGE_REQUEST
];

export const DUPLICATE_SUPPORTED_REQUEST_TYPES = [
  PRODUCTION_REQUEST,
  BIF_PRODUCTION_REQUEST,
  IH_PRODUCTION_REQUEST,
  FINANCIAL_SERVICES_REQUEST,
  POP_PRODUCTION_REQUEST,
  PRODUCTION_REQUEST_3RD_PARTY,
  CARD_DESIGN_REQUEST,
  POP_DESIGN_REQUEST,
  IMAGE_REQUEST
];

export const CHANGE_OWNER_REQUEST_TYPES = [
  POP_PRODUCTION_REQUEST,
  POP_DESIGN_REQUEST,
  CARD_DESIGN_REQUEST,
  PRODUCTION_REQUEST,
  FINANCIAL_SERVICES_REQUEST,
  BIF_PRODUCTION_REQUEST,
  PRODUCTION_REQUEST_3RD_PARTY,
  IH_PRODUCTION_REQUEST,
  IMAGE_REQUEST
];

export enum REQUEST_TYPE {
  CPR = 'PRODUCTION_REQUEST',
  CDR = 'CARD_DESIGN_REQUEST',
  PPR = 'POP_PRODUCTION_REQUEST',
  PDR = 'POP_DESIGN_REQUEST',
  FSR = 'FINANCIAL_SERVICES_REQUEST',
  BPR = 'BIF_PRODUCTION_REQUEST',
  TPPR = 'PRODUCTION_REQUEST_3RD_PARTY',
  DAR = 'DIGITAL_ASSETS_REQUEST',
  IPR = 'IH_PRODUCTION_REQUEST',
  IR = 'IMAGE_REQUEST',
}

export const REQUEST_TYPES = [
  {
    label: 'Production Request',
    value: PRODUCTION_REQUEST_3RD_PARTY
  },
  {
    label: 'BIF Production Request',
    value: BIF_PRODUCTION_REQUEST
  },
  {
    label: 'Card Design Request',
    value: CARD_DESIGN_REQUEST
  },
  {
    label: 'Digital Assets Request',
    value: DIGITAL_ASSETS_REQUEST
  },
  {
    label: 'Financial Services Request',
    value: FINANCIAL_SERVICES_REQUEST
  },
  {
    label: 'IH Production Request',
    value: IH_PRODUCTION_REQUEST
  },
  {
    label: 'POP Design Request',
    value: POP_DESIGN_REQUEST
  },
  {
    label: 'POP Production Request',
    value: POP_PRODUCTION_REQUEST
  },
  {
    label: 'Production Request (Legacy)',
    value: PRODUCTION_REQUEST
  },
  {
    label: 'Image Request',
    value: IMAGE_REQUEST
  },
];
